import { Framework } from '../../types/dynamodb';
import { ListFrameworksResponse, NexusApiService } from '../nexusApiService';

/**
 * Backend-aligned UI client for NexusFrameworkService APIs.
 */
export class NexusFrameworkService {
  constructor(private readonly api: NexusApiService) {}

  async listFrameworks(params?: {
    status?: string;
    maxResults?: number;
    nextToken?: string;
  }): Promise<ListFrameworksResponse> {
    return this.api.listFrameworks(params);
  }

  async listFrameworkVersions(
    frameworkName: string,
    params?: { maxResults?: number; nextToken?: string }
  ): Promise<ListFrameworksResponse> {
    return this.api.listFrameworkVersions(frameworkName, params);
  }

  async getFramework(
    frameworkName: string,
    frameworkVersion: string
  ): Promise<Framework> {
    return this.api.getFramework(frameworkName, frameworkVersion);
  }
}

